import { useState } from 'react'
import { useAppUpdate } from '../lib/pwa'
import { Icon } from './Icon'
import './UpdateBanner.css'

/**
 * La proposition de mise à jour.
 *
 * Monté à la racine, à côté de `App` : une nouvelle version concerne aussi le
 * portail d'entrée et le panneau d'administration, qui sortent de l'app avant
 * même qu'un portefeuille existe.
 *
 * Il porte aussi l'enregistrement du service worker — donc il doit rester monté
 * même quand il n'affiche rien.
 *
 * « Plus tard » ne refuse pas la version : elle reste installée et en attente,
 * et sera reproposée au prochain démarrage. Rien ne s'applique dans le dos de
 * l'utilisateur, qui peut être en train de saisir un montant.
 */
export function UpdateBanner() {
  const { updateAvailable, applyUpdate } = useAppUpdate()
  const [dismissed, setDismissed] = useState(false)

  if (!updateAvailable || dismissed) return null

  return (
    <div className="update-banner" role="status">
      <span className="update-banner-icon" aria-hidden="true">
        <Icon name="refresh" size={18} />
      </span>
      <p>
        <strong>Une nouvelle version d'Ariariko est prête.</strong>
        {' '}Tes données restent en place.
      </p>
      <div className="update-banner-actions">
        <button type="button" className="update-banner-later"
                onClick={() => setDismissed(true)}>
          Plus tard
        </button>
        <button type="button" onClick={applyUpdate}>Mettre à jour</button>
      </div>
    </div>
  )
}
